/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import {
  Grid,
  Box,
  Button,
  CircularProgress,
  Typography,
  Stack,
} from '@mui/material';
import { Form, Formik, FormikState } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { setAlert } from '@/store/slices/alert';
import { selectOrder } from '@/store/selectors';
import { updatePaymentMethod } from '@/store/slices/order';
import {
  useAddPayment,
  useFetchPosProfileDetails,
  // useDeleteDraftInvoice,
} from '@/services/hooks';

import AmountLeft from './helpers/AmountLeft';
import Change from './helpers/Change';

const inputBox = {
  height: '44px',
  width: '100%',
  display: 'flex',
  gap: '10px',
  alignItems: 'center',
  borderRadius: '8px',
  border: 'none',

  '& input': {
    width: '226px',
    height: '44px',
    borderRadius: '8px',
    border: '1px solid #D9D9D9',
    fontFamily: 'inherit',
    px: 2,

    '&:focus': {
      outline: 'none',
    },
  },
};

let initialState: any = {};

const AddPaymentForm = () => {
  const { current_invoice, taxes, discount, paid_amount, sub_total, total } =
    useSelector(selectOrder);
  const dispatch = useDispatch();
  const { data: profile } = useFetchPosProfileDetails();
  const { mutate, isLoading } = useAddPayment();

  const paymentState = profile?.payments.reduce((total: any, current: any) => {
    total[current.mode_of_payment] = 0;
    return total;
  }, {});

  initialState = { ...paymentState };

  const handleSplit = (values: typeof initialState) => {
    const updatedPaymentAmount = profile?.payments.map((curr: any) => {
      const paymentsObject = {
        ...curr,
        amount: values[curr.mode_of_payment],
      };

      return paymentsObject;
    });

    // Filter out payments options that amounts to zero
    const paymentItems = updatedPaymentAmount.filter(
      (item: any) => item.amount !== 0 && item.amount !== '',
    );

    const amountToBePaid = paymentItems.reduce(
      (total: any, curr: any) => total + curr.amount,
      0,
    );

    // Create the payment object
    const paymentObj = {
      invoice_name: current_invoice,
      payment_mode: 'CASH',
      amount: amountToBePaid,
    };

    return paymentObj;
  };
  const handleUpdatePaymentMethod = (payments: Array<Record<string, any>>) => {
    const paymentMethods = payments.map((payment) => ({
      type: payment.mode_of_payment,
      amount: payment.amount,
    }));

    dispatch(updatePaymentMethod(paymentMethods));
  };
  const handleSubmit = (values: typeof initialState) => {
    const paymentObj = handleSplit(values);

    // eslint-disable-next-line arrow-body-style
    const totalAmount = paymentObj.amount;

    const amountIsComplete = totalAmount >= total - paid_amount;

    if (!amountIsComplete) {
      dispatch(
        setAlert({
          type: 'error',
          message: 'Amount not completed yet!',
        }),
      );
    } else {
      handleUpdatePaymentMethod([
        { mode_of_payment: paymentObj.payment_mode, amount: paymentObj.amount },
      ]);

      mutate(paymentObj);
    }
  };

  const handleAutoFill = (
    name: string,
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean | undefined,
    ) => void,
    resetForm: (nextState?: Partial<FormikState<any>> | undefined) => void,
  ) => {
    resetForm();
    setFieldValue(name, total - paid_amount);
  };

  return (
    <Box mt={6}>
      <Formik initialValues={initialState} onSubmit={handleSubmit}>
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <Grid container columnSpacing={4} rowSpacing={4}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    border: '1px solid #D9D9D9',
                    borderRadius: '20px',
                    backgroundColor: '#fff',
                    width: '100%',
                    maxHeight: '200px',
                    height: '200px',
                    overflow: 'auto',
                    padding: '32px 45px',
                  }}
                >
                  <Stack
                    direction="row"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mx: 'auto',
                      mb: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        color: (theme) => theme.palette.primary.main,
                        fontWeight: '600',
                        fontFamily: 'Montserrat',
                      }}
                    >
                      Subtotal
                    </Typography>
                    <Typography
                      sx={{
                        color: (theme) => theme.palette.primary.main,
                        fontWeight: '600',
                        fontFamily: 'Montserrat',
                      }}
                    >
                      {profile?.currency}
                      {sub_total.toLocaleString('en-US')}
                    </Typography>
                  </Stack>
                  {taxes.map((tax) => (
                    <Stack
                      key={tax.account_head}
                      direction="row"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mx: 'auto',
                        mb: 1,
                      }}
                    >
                      <Typography fontFamily="Montserrat">
                        {tax.description}
                      </Typography>
                      <Typography fontFamily="Montserrat">
                        {profile?.currency}
                        {tax.tax_amount}
                      </Typography>
                    </Stack>
                  ))}

                  <Stack
                    direction="row"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mx: 'auto',
                      mb: 1,
                    }}
                  >
                    <Typography fontFamily="Montserrat">Discount</Typography>
                    <Typography fontFamily="Montserrat">
                      {profile?.currency}
                      {discount.toLocaleString()}
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mx: 'auto',
                      mb: 1,
                    }}
                  >
                    <Typography fontFamily="Montserrat">Amount Paid</Typography>
                    <Typography fontFamily="Montserrat">
                      {profile?.currency}
                      {paid_amount.toLocaleString()}
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mx: 'auto',
                      mb: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        color: (theme) => theme.palette.primary.main,
                        fontWeight: '600',
                        fontFamily: 'Montserrat',
                      }}
                    >
                      Total
                    </Typography>
                    <Typography
                      sx={{
                        color: (theme) => theme.palette.primary.main,
                        fontWeight: '600',
                        fontFamily: 'Montserrat',
                      }}
                    >
                      {profile?.currency}
                      {(total - paid_amount).toLocaleString('en-US')}
                    </Typography>
                  </Stack>
                </Box>
              </Grid>

              <Grid item xs={8} sx={{ mx: 'auto' }}>
                <AmountLeft />
                <Change />
              </Grid>

              {/* PAYMENT METHODS */}
              <Grid item xs={8} sx={{ mx: 'auto' }}>
                <Box>
                  {profile?.payments.map((payment: any) => (
                    <Box sx={inputBox} key={payment.name} mb="20px">
                      <input
                        name={payment.mode_of_payment}
                        type="number"
                        value={props.values[payment.mode_of_payment]}
                        onChange={props.handleChange}
                      />
                      <Button
                        type="button"
                        variant="contained"
                        disableElevation
                        onClick={() => {
                          handleAutoFill(
                            payment.mode_of_payment,
                            props.setFieldValue,
                            props.resetForm,
                          );
                        }}
                        sx={{
                          borderRadius: 2,
                          width: '154px',
                          height: '44px',
                        }}
                      >
                        {payment.mode_of_payment}
                      </Button>
                    </Box>
                  ))}
                </Box>
              </Grid>

              {/* SUBMIT BUTTON */}
              <Grid item xs={6} sx={{ mx: 'auto' }}>
                {isLoading ? (
                  <CircularProgress />
                ) : (
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ borderRadius: 2 }}
                  >
                    Submit Payment
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default AddPaymentForm;
